import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import easeInTopGif from '../../../assets/images/transitions/easeInTop.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_IN_TOP = 'easeInTop';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeInTopPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_IN_TOP,

  // A human friendly name for the preset.
  humanName: 'Ease In & Rotate From Top',

  // A preview of the transition.
  gif: easeInTopGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'position.y': {
      time: {
        start: 'start.0',
        end: 'start.1000'
      },
      easing: EASINGS.easeOutPower3,
      values: [
        'off.top',
        'position.top'
      ],
      immediateRender: true
    },
    'transform.rotate': {
      time: {
        start: 'start.0',
        end: 'start.1000'
      },
      easing: EASINGS.easeOutPower3,
      values: [
        '90',
        '0'
      ],
      immediateRender: true
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_IN_TOP,
    options: {},
  },
};

easeInTopPresetDetails.template.options = lodash.cloneDeep(easeInTopPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_IN_TOP;

// This defines the value of the presets object.
export default easeInTopPresetDetails;
